<section *ngIf="(activeStepIndex$ | async) !== undefined">
  <div class="d-flex flex-column" *ngIf="steps$ | async as steps">
    <ul class="d-flex flex-row align-items-start m-0">
      <li class="flex-grow-1" [class.checked]="true" [class.active]="true">
        <a
          class="text-decoration-none d-flex flex-column align-items-center"
          [routerLink]="{ cxRoute: 'cart' } | cxUrl"
          ngbTooltip="{{ 'habaMiniCart.cart' | cxTranslate }}"
          placement="bottom"
          triggers="hover"
          tooltipClass="tooltip-style"
        >
          <span class="index-wrapper">
            <span
              class="index d-flex justify-content-center align-items-center font-bold hovered"
              [style.cursor]="'pointer'"
            >
              <svg class="icon icon-style">
                <use href="/common/assets/icons/checkout/cart.svg#svg"></use>
              </svg>
            </span>
            <ng-template [ngTemplateOutlet]="overlayCheck"></ng-template>
          </span>
        </a>
      </li>

      <ng-container *ngFor="let step of steps; let i = index">
        <li
          class="flex-grow-1"
          [class.active]="isActive(i)"
          [class.disabled]="isDisabled(i)"
          [class.checked]="getTabIndex(i) === 0"
        >
          <div class="d-flex align-items-center">
            <span class="progress"></span>
            <a
              class="text-decoration-none d-flex flex-column align-items-center"
              (click)="changeStep(step, i)"
              [class.active]="isActive(i)"
              [class.disabled]="isDisabled(i)"
              [tabindex]="getTabIndex(i)"
              ngbTooltip="{{ step.name | cxTranslate }}"
              placement="bottom"
              triggers="hover"
              tooltipClass="tooltip-style"
              [disableTooltip]="isActive(i)"
            >
              <span class="index-wrapper">
                <span
                  class="index d-flex justify-content-center align-items-center font-bold hovered"
                  [style.cursor]="'pointer'"
                  *ngIf="!isActive(i)"
                >
                  <svg class="icon icon-style">
                    <use [attr.xlink:href]="step.iconPath"></use>
                  </svg>
                </span>
                <ng-template
                  *ngIf="getTabIndex(i) === 0"
                  [ngTemplateOutlet]="overlayCheck"
                ></ng-template>

                <span
                  class="index-active d-flex justify-content-center align-items-center"
                  [style.cursor]="'default'"
                  *ngIf="isActive(i)"
                >
                  <svg class="icon icon-style">
                    <use [attr.xlink:href]="step.iconPath"></use>
                  </svg>
                  <span class="name text-center" [style.cursor]="'default'">{{
                    step.name | cxTranslate
                  }}</span>
                </span>
              </span>
            </a>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</section>

<ng-template #overlayCheck>
  <span
    class="index overlay-check d-flex justify-content-center align-items-center font-bold hovered"
    [style.cursor]="'pointer'"
  >
    <svg class="icon icon-size-20">
      <use href="/common/assets/icons/check.svg#svg"></use>
    </svg>
  </span>
</ng-template>
